import { Injectable, Injector, ErrorHandler, NgZone } from "@angular/core";
import { CoreLogService } from "./log.service";
import { XHRBackend, ConnectionBackend, BrowserXhr, ResponseOptions, XSRFStrategy, BaseResponseOptions, CookieXSRFStrategy, RequestOptions, BaseRequestOptions } from "@angular/http";
import { HttpClient } from "@angular/common/http";


@Injectable()
export class CoreGlobalErrorHandlerService extends ErrorHandler {

    public handleError(error) {

        // TODO: Serverseitig loggen

        super.handleError(error);
    }

    constructor(private injector: Injector) {
        super();
    }

}
